import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import EditIcon from "@mui/icons-material/EditOutlined";
import "../../../styles/admin/promptPopup.scss";

const CreatePersonaPopup = ({
  open,
  onClose,
  onSave,
  personaType,
  initialPersona,
  readOnly = false,
  onEditClick,
}) => {
  const [name, setName] = useState("");
  const [persona, setPersona] = useState("");
  const [saving, setSaving] = useState(false);

  const isEval = personaType === "eval";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (readOnly) return;
    if (!name.trim() || !persona.trim()) return;
    const payload = {
      name: name.trim(),
      persona: persona.trim(),
      persona_type: initialPersona?.persona_type || personaType,
      is_active: initialPersona?.is_active ?? true,
    };
    try {
      setSaving(true);
      if (onSave) {
        await onSave(payload);
      }
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    if (open) {
      if (initialPersona) {
        setName(initialPersona.name || "");
        setPersona(initialPersona.persona || "");
      } else {
        setName("");
        setPersona("");
      }
      setSaving(false);
    }
  }, [open, initialPersona]);

  if (!open) return null;

  return createPortal(
    <div
      className="common-popup-overlay high-z-index persona-create-popup"
    >
      <div
        className="common-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header with-close">
          <h2>{isEval ? "System Prompt" : "Persona"}</h2>
          <button
            type="button"
            className="popup-close-button"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
          <div className="popup-content" style={{ flex: 1, overflowY: 'auto' }}>
            <div className="popup-form-group">
              <label>Name</label>
              <input
                type="text"
                className="popup-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                readOnly={readOnly}
                placeholder={isEval ? "Prompt name" : "Persona name"}
              />
            </div>

            <div className="popup-form-group">
              <label>{isEval ? "System Prompt" : "Persona"}</label>
              <textarea
                className="popup-textarea"
                rows={8}
                value={persona}
                onChange={(e) => setPersona(e.target.value)}
                readOnly={readOnly}
                placeholder={isEval ? "Enter system prompt instructions" : "Enter persona instructions"}
                style={{ minHeight: 300, color: "var(--color-text-light)" }}
              />
            </div>
          </div>

          <div className="popup-actions" style={{ padding: '16px 20px', borderTop: '1px solid var(--secondary-border)', background: 'var(--color-bg)', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
            {readOnly ? (
              <>
                <button
                  type="button"
                  className="popup-cancel-button"
                  onClick={onClose}
                >
                  Close
                </button>
                {onEditClick && (
                  <button
                    type="button"
                    className="popup-submit-button"
                    onClick={onEditClick}
                  >
                    <EditIcon fontSize="small" style={{ marginRight: '6px' }} />
                    {isEval ? "Edit System Prompt" : "Edit Persona"}
                  </button>
                )}
              </>
            ) : (
              <>
                <button
                  type="button"
                  className="popup-cancel-button"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="popup-submit-button"
                  disabled={saving || !name.trim() || !persona.trim()}
                >
                  {saving ? "Saving..." : isEval ? "Save Prompt" : "Save Persona"}
                </button>
              </>
            )}
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default CreatePersonaPopup;
